import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'priceSeparator',
  standalone: true,
})
export class PriceSeparatorPipe implements PipeTransform {
  transform(value: number | string | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }

    const num = value.toString().replace(/,/g, '');

    return num.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
